<template>
  <div id="ag-grid-demo">
    <!-- <p>{{ tab }}</p> -->

    <div class="pl-2">
      <div
        class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
      >
        <!-- <vs-input
          class="mb-4 md:mb-0 mr-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        /> -->
        <!-- <div class="mb-2">
          <top-button></top-button>
        </div> -->
      </div>

      <div class="mt-4">
        <!-- TABLE ACTION ROW -->
        <div class="flex flex-wrap justify-between items-center">
          <!-- ITEMS PER PAGE -->
          <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left"></div>

          <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        </div>
        <div
          class="grid grid-cols-3 my-6"
          v-if="
            nowPage == 'Booking' || nowPage == 'Pay Out' || nowPage == 'Reciept'
          "
        >
          <div class="col-span-1 flex">
            <p class="m-2 text-xl font-semibold text-primary">Year</p>
            <vs-dropdown
              :color="$primary"
              class="border_primary border_radius"
              style="
                border-radius: 5px;
                border: solid 1px #707070;
                min-width: 122px !important;
              "
            >
              2020
              <vs-icon icon="expand_more"></vs-icon>

              <vs-dropdown-menu>
                <vs-dropdown-item> option 1 </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
          <div class="col-span-2 flex">
            <div class="flex">
              <p class="m-2 pr-2 text-xl font-semibold text-primary">Start</p>
              <vs-dropdown
                :color="$primary"
                class="border_primary border_radius"
                style="
                  border-radius: 5px;
                  border: solid 1px #707070;
                  min-width: 122px !important;
                "
              >
                12/01/2020
                <vs-icon icon="expand_more"></vs-icon>

                <vs-dropdown-menu>
                  <vs-dropdown-item> option 1 </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
            <div class="flex">
              <p class="m-2 px-2 text-xl font-semibold text-primary">To</p>
              <vs-dropdown
                :color="$primary"
                class="border_primary border_radius"
                style="
                  border-radius: 5px;
                  border: solid 1px #707070;
                  min-width: 122px !important;
                "
              >
                31/01/2020
                <vs-icon icon="expand_more"></vs-icon>

                <vs-dropdown-menu>
                  <vs-dropdown-item> option 1 </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
        </div>
        <!-- NOTE tableเริ่มตรงนี้ -->
        <!-- <button @click="getSelectedRowData()" style="margin: 10px">
          Get Selected Nodes
        </button> -->
        <tab-component></tab-component>
        <ag-grid-vue
          style="height: 70vh;"
          ref="agGridTable"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 ag-grid-table"
          :columnDefs="getTable.column"
          :defaultColDef="defaultColDef"
          :rowData="getTable.data"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :enableRtl="$vs.rtl"
          @first-data-rendered="onFirstDataRendered"
          @rowDataChanged="onFirstDataRendered"
          :setQuickFilter="updateSearchQuery"
          @gridReady="onGridReady"
        >
        </ag-grid-vue>
        <vs-pagination
          v-if="totalPages > 1"
          class="mt-3"
          :total="totalPages"
          :max="maxPageNumbers"
          v-model="currentPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
// NOTE componentแต่ละtypeสำหรับแต่ละช่องในตาราง
// ใช้ตอนback-endส่งcellRendererFrameworkตรงกับชื่อcomponent
import { AgGridVue } from "ag-grid-vue";
import topButton from "../topTableButton/topTableButton";
import { mapGetters } from "vuex";
import iconDetail from "./table_component/iconDetail";
import iconDelete from "./table_component/iconDelete";
import tabComponent from "./../tabComponent/tabComponent";
import Dropdown from "./table_component/Dropdown";
import String from "./table_component/String";
import Date from "./table_component/Date";
import Float from "./table_component/Float";
import Number from "./table_component/Number";
import Array from "./table_component/Array";
import More from "./table_component/More";
import SeeDetail from "./table_component/SeeDetail";
import iconInfo from "./table_component/iconInfo";
import Percent from "./table_component/Percent";
import iconDownload from "./table_component/iconDownload";
import FileManagement from "./table_component/FileManagement";
import ReceiptNet from "./table_component/ReceiptNet";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import themeConfig from "@/../themeConfig.js";

export default {
  props: ["searchQuery"],
  components: {
    AgGridVue,
    iconDetail,
    iconDelete,
    tabComponent,
    topButton,
    Dropdown,
    String,
    Date,
    Float,
    Number,
    Array,
    More,
    SeeDetail,
    iconInfo,
    Percent,
    iconDownload,
    FileManagement,
    ReceiptNet,
  },
  data() {
    return {
      bermuda: null,
      // searchQuery: "",
      gridOptions: { resizable: true },
      maxPageNumbers: 7,
      gridApi: "sizeColumnsToFit",
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true,
        rowSelection: "multiple",
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn,
      },
    };
  },

  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("email", null);
      } else this.gridOptions.columnApi.setColumnPinned("email", "left");
    },
    searchQuery() {
      this.updateSearchQuery(this.searchQuery);
    },
  },
  computed: {
    ...mapGetters({
      getTable: "general/table",
      nowPage: "getNowPage",
    }),
    // ...mapGetter({

    // }),

    // TODO เปลี่ยนหน้าตาราง
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 12;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    changeTabActive(index) {
      this.$store.dispatch("home/changeTabActive", index);
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady() {
      this.gridApi = this.gridOptions.api;
      this.gridColumnApi = this.gridOptions.columnApi;
    },
    isFirstColumn(params) {
      var displayedColumns = params.columnApi.getAllDisplayedColumns();
      var thisIsFirstColumn = displayedColumns[0] === params.column;
      return thisIsFirstColumn;
    },
    getSelectedRowData() {
      let selectedNodes = this.gridApi.getSelectedNodes();
      let selectedData = selectedNodes.map((node) => node.data);
      // alert(`Selected Nodes:\n${JSON.stringify(selectedData)}`);
      console.log(selectedData);
      return selectedData;
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.bermuda = themeConfig.theme.bermuda;
    // console.log(this.getTable);
    // this.$store.dispatch("home/getTabComponent");
  },
};
</script>
